import * as Permissions from '@/js/libs/generated/permissions/types';
import * as Types from './types';
export var FileUploadStatus;
(function (FileUploadStatus) {
    FileUploadStatus["NOT_UPLOADED"] = "NOT_UPLOADED";
    FileUploadStatus["LINK_CREATED"] = "LINK_CREATED";
    FileUploadStatus["LINK_EXPIRED"] = "LINK_EXPIRED";
    FileUploadStatus["UPLOADED"] = "UPLOADED";
})(FileUploadStatus || (FileUploadStatus = {}));
export var VirusScanStatus;
(function (VirusScanStatus) {
    VirusScanStatus["NOT_SCANNED"] = "NOT_SCANNED";
    VirusScanStatus["SCAN_FAILED"] = "SCAN_FAILED";
    VirusScanStatus["SCAN_SUCCESSFUL"] = "SCAN_SUCCESSFUL";
})(VirusScanStatus || (VirusScanStatus = {}));
